
  import { Vue, Component, Prop } from "vue-property-decorator";

  import { getSectionRouteName } from "@/helpers/routes/getSectionRouteName";
  import RouteNames from "@/entities/RouteNames";

  @Component
  export default class GetRelativeRouteNameMixin extends Vue {
    getRelativeRouteName(routeName: RouteNames) {
      const prefixes = this.$route.matched.map((match) => match.meta?.breadcrumb?.prefix).filter(Boolean);

      if (prefixes.length === 0) {
        return routeName;
      }

      const lastPrefix = prefixes[prefixes.length - 1];

      return getSectionRouteName({
        routeName,
        prefix: lastPrefix,
      });
    }
  }
